import { COLORS } from '../constants'

const selection = [COLORS.RED, COLORS.BLUE, COLORS.YELLOW]

const generateRandomColor = () =>
  selection[Math.floor(Math.random()*selection.length)]

export default generateRandomColor